import wowLogo from '../assets/wowvegas-logo.svg'
import rollaLogo from '../assets/rolla-logo.svg'

type Brand = 'WOWVEGAS' | 'ROLLA' | null

export function Logo({
  brand = 'WOWVEGAS',
  className = 'h-5 w-auto',
}: {
  brand?: Brand
  className?: string
}) {
  if (brand === 'ROLLA') return <img src={rollaLogo} alt="Rolla" className={className} />
  if (brand === null) {
    // "All brands" — both marks inline
    return (
      <div className="inline-flex items-center gap-3">
        <img src={wowLogo} alt="WOW Vegas" className={className} />
        <span className="text-slate-600 text-sm">·</span>
        <img src={rollaLogo} alt="Rolla" className={className} />
      </div>
    )
  }
  return <img src={wowLogo} alt="WOW Vegas" className={className} />
}
